import PropTypes from "prop-types";
import React, { useState } from "react";
import { VisionAppDisplay } from "components/app";
import { Button } from "components/buttons";
import { Intent } from "@blueprintjs/core";
import { v4 as uuid } from "uuid";
import { TemplateBuilderMediaCapturePreview } from "../../mediaCapture/TemplateBuilderMediaCapturePreview";
import "./DefectCapturePreview.css";

export function DefectCapturePreview({ question, answer, onChange, onClose }) {
    const [rows, setRows] = useState(answer?.defects || [{ comment: "", media: [], defectReference: uuid() }]);

    const handleAddRow = () => {
        setRows([...rows, { comment: "", media: [], defectReference: uuid() }]);
    };

    const onDelete = (index) => {
        const updatedRows = rows.filter((_, i) => i !== index);
        setRows(updatedRows);

        if (updatedRows.length === 0) {
            handleAddRow();
        }
    };

    const handleCommentChange = (index, value) => {
        const updatedRows = [...rows];
        updatedRows[index].defectComment = value;
        setRows(updatedRows);
    };

    const handleMediaChange = (index, mediaData) => {
        const updatedRows = [...rows];
        updatedRows[index].media = mediaData.answer || [];
        setRows(updatedRows);
    };

    const handleClose = () => {
        onClose();
    };

    const handleFinish = () => {
        onChange({
            ...answer,
            defects: rows
        });
        onClose();
    };

    return (
        <VisionAppDisplay
            show={true}
            onClose={handleClose}
            header={
                <div className="check-preview-defect-header inline-items">
                    <Button
                        icon="arrow-left"
                        onClick={handleClose}
                    />
                    <h4 className="spacer-left">Create a New Defect</h4>
                </div>
            }
            className="check-preview-defect-capture"
        >
            <div className="check-preview-helper-text">
                Upload the details of your defect below. You can add multiple rows to upload more than one defect.
            </div>
            <div className="check-preview-scroll-view">
                {rows.map((row, index) => (
                    <div key={`scroll-view-${row.defectReference}`} className="check-preview-defect-row">
                        <div className="textarea-helper-text">
                            <p>Please comment on the defect</p>
                            <Button
                                icon="small-cross"
                                iconOnly={true}
                                className="check-preview-remove-defect-button"
                                minimal={true}
                                onClick={() => onDelete(index)}
                            />
                        </div>
                        <textarea
                            className="check-preview-defect-textarea"
                            onChange={(event) => handleCommentChange(index, event.currentTarget.value)}
                            value={row.defectComment ? row.defectComment : ""}
                        >
                        </textarea>
                        <div>
                        <div className="check-preview-textarea-helper-text">
                            <p>Upload evidence of the defect:</p>
                        </div>
                            <TemplateBuilderMediaCapturePreview
                                question={{
                                    ...question,
                                    allowImages: true,
                                    allowVideos: true,
                                }}
                                answer={{
                                    answer: row.media,
                                    questionId: question.id
                                }}
                                onChange={(updatedAnswer) =>
                                    handleMediaChange(index, updatedAnswer)
                                }
                            />
                        </div>
                    </div>
                ))}
                <div key={"scroll-view-add-row"} className="check-preview-defect-row">
                    <Button
                        text="Add new row"
                        icon="add"
                        className="check-preview-add-row-button"
                        onClick={handleAddRow}
                    />
                </div>
                <div>
                    <Button
                        text="Finish adding defects"
                        intent={Intent.PRIMARY}
                        onClick={handleFinish}
                        className="check-preview-finish-defects-button"
                    />
                    <Button
                        text="Cancel"
                        onClick={handleClose}
                        className="check-preview-cancel-defects-button"
                    ></Button>
                </div>
            </div>
        </VisionAppDisplay>
    );
}

DefectCapturePreview.propTypes = {
    answer: PropTypes.object,
    question: PropTypes.object.isRequired,
    onChange: PropTypes.func.isRequired,
    onClose: PropTypes.func.isRequired
};